"use strict";
/* IMPORT */
Object.defineProperty(exports, "__esModule", { value: true });
/* CHANGES SUBSCRIBERS */
const ChangesSubscribers = {
    /* VARIABLES */
    subscribers: new WeakMap(),
    /* API */
    get: (store) => {
        return ChangesSubscribers.subscribers.get(store);
    },
    set: (store, subscriber) => {
        ChangesSubscribers.subscribers.set(store, subscriber);
    }
};
/* EXPORT */
exports.default = ChangesSubscribers;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2hhbmdlc19zdWJzY3JpYmVycy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9jaGFuZ2VzX3N1YnNjcmliZXJzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFDQSxZQUFZOztBQUtaLHlCQUF5QjtBQUV6QixNQUFNLGtCQUFrQixHQUFHO0lBRXpCLGVBQWU7SUFFZixXQUFXLEVBQUUsSUFBSSxPQUFPLEVBQTZCO0lBRXJELFNBQVM7SUFFVCxHQUFHLEVBQUUsQ0FBRSxLQUFZLEVBQWtDLEVBQUU7UUFFckQsT0FBTyxrQkFBa0IsQ0FBQyxXQUFXLENBQUMsR0FBRyxDQUFHLEtBQUssQ0FBRSxDQUFDO0lBRXRELENBQUM7SUFFRCxHQUFHLEVBQUUsQ0FBRSxLQUFZLEVBQUUsVUFBNkIsRUFBUyxFQUFFO1FBRTNELGtCQUFrQixDQUFDLFdBQVcsQ0FBQyxHQUFHLENBQUcsS0FBSyxFQUFFLFVBQVUsQ0FBRSxDQUFDO0lBRTNELENBQUM7Q0FFRixDQUFDO0FBRUYsWUFBWTtBQUVaLGtCQUFlLGtCQUFrQixDQUFDIn0=